import { useEffect, useRef, useState } from "react";
import MobileHeader from "../../../layout/OwnerLayout/Header";
import { Box, Typography } from "@mui/material";
import InfoBox from "./InfoBox";

import TicketsBox from "../../Driver/SuportPage/TicketsBox";
import ContactInfo from "../../Driver/SuportPage/ContactInfo";

export default function SuportPage() {
  const divRef = useRef<HTMLDivElement>(null);
  const [hasScroll, setHasScroll] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      if (divRef.current && divRef.current.scrollTop > 5) {
        setHasScroll(true);
      } else {
        setHasScroll(false);
      }
    };

    if (divRef.current) {
      divRef.current.addEventListener("scroll", handleScroll);
    }

    return () => {
      if (divRef.current) {
        divRef.current.removeEventListener("scroll", handleScroll);
      }
    };
  }, []);

  return (
    <>
      <MobileHeader title={getHeaderTitle()} hasScroll={hasScroll} />
      <Box
        ref={divRef}
        sx={{
          flex: "1",
          overflowY: "auto",
          paddingX: "8px",
        }}
      >
        <InfoBox />
        <ContactInfo />
        <TicketsBox />
      </Box>
    </>
  );
}

function getHeaderTitle() {
  return (
    <Typography
      sx={{
        fontWeight: 600,
        color: "secondary.main",
        fontSize: 16,
      }}
    >
      پشتیبانی{" "}
    </Typography>
  );
}
